<template>

    <div>

        <transition name="modal">
            <employee-modal
                :employee_id="modal_employee_id"
                :tab="modal_tab"
                @close="closeModal()"
                @refresh="refresh()"
                @createNew="createEmployee()"
                v-if="modal_employee_id"
            />
        </transition>

        <div class="row g-3 mb-4">

            <div class="col-24 col-md-5 mb-4 mb-md-0">
                <input type="text"
                       class="form-control new-list-group-field"
                       placeholder="Sök namn, kontaktuppgifter, övriga fält"
                       v-model="settings.query.text"
                >
            </div>

            <div class="col-24 col-md-3 mb-4 mb-md-0">
                <select class="form-select new-list-group-field" v-model="settings.query.status">
                    <option :value="null">Status</option>
                    <option>Importerad</option>
                    <option>Inbjuden</option>
                    <option>Aktiverad</option>
                    <option>Inaktiverad</option>
                </select>
            </div>

            <div class="col-24 col-md-4">
                <select class="form-select new-list-group-field" v-model="settings.query.workplace">
                    <option :value="null">Arbetsplats</option>
                    <option :key="'w'+workplace.id" :value="workplace.id" v-for="workplace in workplaces">{{ workplace.title }}</option>
                </select>
            </div>

            <div class="col-24 col-md-2">
                <div class="form-check pt-2">
                    <input class="form-check-input" type="checkbox" value="" id="filter-invalid_import" v-model="settings.query.invalid_import">
                    <label class="form-check-label tooltip-target" for="filter-invalid_import">
                        Felaktig
                        <div class="tooltip-label">Filtrera importerade konton där mobilnummer eller e-post är felaktiga.</div>
                    </label>
                </div>
            </div>

            <div class="col-24 col-md-10 d-flex justify-content-end">
                <button class="btn btn-primary btn-sm me-2" @click="createEmployee()">Lägg till anställd
                    <div class="tooltip-label">Lägg till en anställd manuellt.</div>
                </button>
                <button class="btn btn-primary btn-sm me-2" :disabled="loadingImport">
                    <div class="position-relative w-100">
                        <input type="file" class="position-absolute w-100 opacity-0" @change="importEmployees()" :disabled="loadingImport" />
                        <span class="spinner-border spinner-border-sm"></span>
                        Importera
                    </div>
                    <div class="tooltip-label">Ladda upp en excel för att importera anställda.</div>
                </button>
                <button class="btn btn-primary btn-sm" @click="openExportModal()">Exportera
                    <div class="tooltip-label">Ladda ner en excel med anställda.</div>
                </button>
            </div>

        </div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">
                <list-item-row
                    :employee="props.item"
                    display-from="company"
                    :bulk_selected.sync="bulk_selected"
                    @openEmployeeModal="openEmployeeModal"
                    @refresh="refresh()"
                />
            </div>
        </list>

    </div>

</template>

<script>
import axios from 'axios'

import employeeModal from '../employees/modal.vue'
import listItemRow from '../employees/list-item-row'

import lister from '../../../../shared/mixins/lister'
import fetcher from '../../../../shared/mixins/fetcher'
import employeeList from '../../../../shared/mixins/employee-list'

export default {

    mixins: [
        lister,
        fetcher,
        employeeList
    ],

    components: {
        employeeModal,
        listItemRow
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            modal_employee_id: null,
            modal_tab: null,

            workplaces: [],
            dynamicFields: [],
            fetcher: {
                autoFill: [
                    'workplaces',
                    'dynamicFields'
                ]
            },

            settings: {
                url: '/companies/' + this.company_id + '/employees/list',
                query: {
                    text: '',
                    status: null,
                    workplace: null,
                    invalid_import: false
                },
                columns: [
                    { column: 'check', name: '', class: 'col-1', sortable: false },
                    { column: 'id', name: 'ID', class: 'col-1', sortable: true, default: true },
                    { column: 'name', name: 'Namn', class: 'col-3', sortable: true },
                    { column: 'phone', name: 'Mobilnummer', class: 'col-3', sortable: true },
                    { column: 'workplace_title', name: 'Arbetsplats', class: 'col-4', sortable: true },
                    { column: 'status', name: 'Status', class: 'col-3', sortable: true },
                    { column: 'created_at', name: 'Registrerad', class: 'col-2', sortable: true },
                    { column: 'last_treatment_at', name: 'Senaste beh.', class: 'col-2', sortable: true },
                    { column: 'buttons', name: '', class: 'col-4', sortable: false }
                ],
                bulk_actions: [
                    { event: 'bulkDisableAccounts', label: 'Inaktivera konton' },
                    { event: 'bulkDeleteAccounts', label: 'Radera konton (rensa all persondata)' },
                    { event: 'bulkInviteAccounts', label: 'Bjud in' }
                ],
                export_fields: [
                    { column: 'id', name: 'ID' },

                    { column: 'status', name: 'Status' },
                    { column: 'created_at', name: 'Registrerad/skapad' },
                    { column: 'invited_at', name: 'Inbjuden' },
                    { column: 'activated_at', name: 'Aktiverad' },

                    { column: 'last_treatment_at', name: 'Senaste behandling' },
                    { column: 'treatments_count', name: 'Antal behandlingar' }
                ]
            },
            loadingImport: false
        }
    },

    computed: {
        fetcherUrl () {
            return '/companies/' + this.company_id + '/employees'
        }
    },

    methods: {

        fetcherSuccess () {
            let spliceAtIndex = 1
            this.dynamicFields.forEach(d => {
                if (d.is_active && d.type !== 'password' && d.type !== 'workplace') {
                    this.settings.export_fields.splice(spliceAtIndex, 0, {
                        column: d.type !== 'text' ? d.type : 'dynamic_field_' + d.id,
                        name: d.label
                    })

                    spliceAtIndex++
                }
            })
        },

        createEmployee () {
            axios.post('/companies/' + this.company_id + '/employees')
                .then(response => {
                    this.modal_employee_id = response.data.employee_id
                })
        },

        importEmployees () {
            this.loadingImport = true

            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)

            axios.post(
                '/companies/' + this.company_id + '/importEmployees',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.refresh()
                    this.loadingImport = false
                })
                .catch(error => {
                    alert('Kunde inte importera filen. Se över filens struktur och försök igen.')
                })
        },

        closeModal () {
            this.modal_employee_id = null
            this.refresh()
        }
    }
}
</script>
<style type="text/css">
/* --- Fade transition --- */
.modal-enter-active, .modal-leave-active {
    opacity: 1;
    transition: all 350ms;
}

.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 500ms ease;
}

.modal-enter, .modal-leave-to {
    opacity: 0;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, -50px);
}
</style>
